import posthog from "posthog-js"

// $exception_steps прилетают к следующему захваченному исключению независимо от
// того, кто его захватил. Единственный способ дотянуть контекст до автозахвата
// (unhandled rejection / window.onerror), где captureException зовём не мы и
// свойства подложить некуда.
export function noteHttpFailure(
	status: number,
	method: string,
	path: string | undefined,
): void {
	posthog.addExceptionStep(`HTTP ${status} ${method} ${path ?? "?"}`, {
		http_status: status,
		http_method: method,
		http_path: path,
	})
}

export function noteNetworkFailure(
	method: string,
	path: string | undefined,
	timedOut: boolean,
): void {
	let phase = "transport"
	if (timedOut) phase = "timeout"
	posthog.capture("network_failure", {
		phase,
		http_method: method,
		http_path: path,
	})
}

export function extractPathname(url: string): string | undefined {
	try {
		return new URL(url).pathname
	} catch {
		return undefined
	}
}
